import { TSTitleCard } from '@/components/shared/card/Card';
import { useTasks } from '@/services/tasks/useTasks';
import { FunctionComponent, useState } from 'react';
import { FiHome } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import adminStrings from '../admin.translations';
import AdminAddTasksModal from './AdminAddTasksModal';
import AdminTasksTable from './AdminTasksTable';

const AdminTasksSection: FunctionComponent = () => {
  const [addTaskModalOpen, setAddTaskModalOpen] = useState(false);

  const navigate = useNavigate();

  const tasks = useTasks();

  const onTaskEdit = (id: string) => {
    navigate(`${id}`);
  };

  return (
    <>
      <TSTitleCard
        title={adminStrings.tasksSection.title}
        icon={FiHome}
        className="w-full"
        primaryAction={{
          label: adminStrings.tasksSection.table.addNew,
          onClick: () => {
            setAddTaskModalOpen(true);
          },
          icon: 'add'
        }}
      >
        <AdminTasksTable tasks={tasks} onEdit={onTaskEdit} />
      </TSTitleCard>
      <AdminAddTasksModal
        open={addTaskModalOpen}
        onClose={() => {
          setAddTaskModalOpen(false);
        }}
      />
    </>
  );
};

export default AdminTasksSection;
